<template>
    <div class="page-shelf-manage">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺設置</div>
            <div class="breadcrumb-item">架號管理</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <Select size="small" style="width: 120px;" placeholder="選擇門店" v-model="uploadFile.store_id" @on-change="handleStoreChange(uploadFile.store_id)">
                        <Option :value="item.ReceivingID" v-for="(item, index) in shopList"
                                :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Upload :before-upload="handleBeforeUpload"
                            accept=".xls, xlsx, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            :format="['xlsx', 'xls']"
                            action="">
                        <div class="upload-file">
                            <template>
                                <span v-if="uploadFile.file && uploadFile.file.name">{{uploadFile.file.name}}</span>
                                <span v-else>導入excel表格</span>
                            </template>
                            <span class="upload-btn">選擇</span>
                        </div>
                    </Upload>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleUplodFile">導入excel</div>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Form :label-width="150">
                    <Row>
                        <Col span="11">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>貨架號</span>
                                </div>
                                <Input v-model="form.code"/>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>貨架類型</span>
                                </div>
                                <Select placeholder="請選擇" v-model="form.type">
                                    <Option :value="1">大</Option>
                                    <Option :value="2">中</Option>
                                    <Option :value="3">小</Option>
                                </Select>
                            </FormItem>
                        </Col>

                        <Col span="11">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>數量</span>
                                </div>
                                <Input v-model="form.count"/>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>門店</span>
                                </div>
                                <Select placeholder="請選擇" v-model="form.store_id" @on-change="handleSearch(form.store_id)">
                                    <Option :value="item.ReceivingID" v-for="(item, index) in shopList"
                                            :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>

                    <FormItem>
                        <div class="pg-btn-wrap pg-form-btn">
                            <div class="pg-btn style1" @click="handleCheckForm">添加</div>
                            <!-- <Button type="error" :loading="true" class="loading-btn">
                                 <span>Loading...</span>
                             </Button>-->
                        </div>
                    </FormItem>
                </Form>
            </div>

            <div class="pg-table-wrap">
                <Table size="small"
                       border
                       no-data-text="暫無數據"
                       :columns="table.column"
                       :data="table.data">
                    <template slot-scope="{ row, index }" slot="action">
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style3" @click="handleViewLabel(index)">生成標簽</div>
                            <div class="pg-btn style2" @click="handleEdit(index)">修改</div>
                            <div class="pg-btn style1" @click="handleDelete(index)">删除</div>
                        </div>
                    </template>
                </Table>

                <div class="pg-pagger">
                    <Row>
                        <Col span="12" class="pagger-left">
                            <div class="pagger-total">總共{{totalCount}}條記錄</div>
                        </Col>
                        <Col span="12" class="pagger-right">
                            <!-- v-if="totalCount > curPageSize" -->
                            <div>
                                <div class="pagger-sizer">
                                    <span>每頁</span>
                                    <Select v-model="curPageSize" size="small" placeholder="數量"
                                            @on-change="handlePageSizeChange">
                                        <Option :value="10">10</Option>
                                        <Option :value="20">20</Option>
                                        <Option :value="30">30</Option>
                                        <Option :value="40">40</Option>
                                        <Option :value="50">50</Option>
                                    </Select>
                                </div>

                                <div class="pagger-elevator">
                                    <span>跳轉</span>
                                    <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                           @on-enter="handlePageEnter"/>
                                </div>

                                <Page size="small"
                                      :current="pageIndex"
                                      :page-size="curPageSize"
                                      :total="totalCount"
                                      @on-change="handlePageChange">
                                </Page>
                            </div>
                        </Col>
                    </Row>
                </div>

            </div>

        </div>
    </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码

                //上传
                uploadFile: {
                    file: '',
                    store_id: ''
                },

                shopList: [],
                form: {
                    code: '',    //货架号
                    count: '',  //存放数量
                    type: '',   //货架类型 1大, 2中, 3小
                    store_id: '',   //门店id
                },
                isSubmiting: false,
                table: {
                    column: [
                        {
                            title: '貨架號',
                            key: 'code',
                            align: 'center',
							sortable: true,
                            minWidth: 80,
                        },
                        {
                            title: '門店',
                            key: 'ReceivingName',
                            align: 'center',
							sortable: true
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 100
                        }
                    ],
                    data: []
                }
            };
        },
        activated()
        {
            this.getShopList();
            this.getList(this.uploadFile.store_id);
        },
        mounted()
        {
            this.getShopList();
            this.getList(this.uploadFile.store_id);
        },
        methods: {
            //上传
            handleBeforeUpload(file)
            {
                this.uploadFile.file = file;
                return false;
            },

            handleUplodFile()
            {
                let uploadFile = this.uploadFile;

                if (uploadFile.store_id == '')
                {
                    this.$Utils.showTipInfo('請選擇門店');
                    return;
                } else if (uploadFile.file == '')
                {
                    this.$Utils.showTipInfo('請選擇文件');
                    return;
                }

                let formData = new FormData();
                formData.append('file', uploadFile.file);
                formData.append('store_id', uploadFile.store_id);

                this.$Rq.requestAuth({
                    url: this.$Api.shelvesUpload,
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess('導入成功');
                        this.uploadFile = {
                            file: '',
                            store_id: ''
                        };

                        this.pageIndex = 1;
                        this.getList(this.uploadFile.store_id);

                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                });
            },

            //获取门店
            getShopList()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                        type: 1   //type 1門店， 2是智能櫃
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.shopList = res.data.data;
                    }
                });
            },
            //根據袋號獲取訂單列表 
            handleSearch()
            {
                if (this.form.sack_number === '')
                {
                    this.table.data = [];
                    return;
                }
                this.getOrderBySackNo(this.form.sack_number);
            },
			handleStoreChange(index) {
				 this.getList(index);
			},
            getList(list)
            {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.shelvesList,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        type: 1, //门店
						store_id: list ? list:0
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
                                id: resData[i].id,
                                code: resData[i].code,
                                store_id: resData[i].store_id,
                                ReceivingName: resData[i].store ? resData[i].store.ReceivingName : ''
                            });
                        }

                        this.totalCount = res.data.count;
                        this.table.data = tempArr;

                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleCheckForm()
            {
                let form = this.form;
                if (form.code === '')
                {
                    this.$Utils.showTipInfo('請輸入貨架號');
                    return;
                } else if (form.count === '')
                {
                    this.$Utils.showTipInfo('請輸入数量');
                    return;
                } else if (form.type === '')
                {
                    this.$Utils.showTipInfo('請選擇貨架類型');
                    return;
                } else if (form.store_id === '')
                {
                    this.$Utils.showTipInfo('請選擇門店');
                    return;
                }

                this.handleSubmit();
            },

            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.shelvesAdd,
                    method: 'post',
                    data: {
                        code: form.code,
                        count: form.count,
                        type: form.type,
                        store_id: form.store_id
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showTipInfo(res.msg);
                        this.form = {
                            code: '',    //货架号
                            count: '',  //存放数量
                            type: '',   //货架类型 1大, 2中, 3小
                            store_id: '',   //门店id
                        };

                        this.getList(this.uploadFile.store_id);
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            //生成标签
            handleViewLabel(index)
            {
                let tableData = this.table.data;
                window.open(this.$Api.shelvesPdf + '/' +tableData[index].id);
            },

            handleEdit(index)
            {
                let tableData = this.table.data;
                this.$router.push({path: '/shelfManageEdit?id=' + tableData[index].id});
            },

            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定删除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.shelvesDelete + '/' + tableData[index].id,
                            method: 'delete',
                        }).then((res) =>
                        {
                            this.isSubmiting = false;

                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);

                                if (tableData.length <= 1 && this.pageIndex > 1)
                                {
                                    this.pageIndex -= 1;
                                }
                                this.getList(this.uploadFile.store_id);
                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });
                    }
                });
            },

            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList(this.uploadFile.store_id);
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList(this.uploadFile.store_id);
            },
            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList(this.uploadFile.store_id);
            }

        }
    };
</script>

<style lang="scss" scoped>
    @import "ShelfManage.scss";
</style>